import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from '@apollo/client/react/hoc';
import { Mutation } from '@apollo/client/react/components';
import compose from 'recompose/compose';

import withServerConfig from 'GraphQL/util/withServerConfig';
import { getAssetList, getUploadUrl, ASSET_TYPE } from 'GraphQL/mutation/Asset.mutation';

import ImageUpload from '../SKUImageUpload';

class SKUImageUpload extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    updateSKUMutation: PropTypes.object,
  };

  handleImageUpdate = (editFn) => ({ key, bucket, url }) => {
    const { id, field } = this.props;
    editFn({
      variables: {
        id,
        data: {
          [field]: { key, bucket },
        },
      },
    });
  };

  handleFileListRequest = async (request) => {
    const { client, id } = this.props;
    const { data } = await client.query({
      query: getAssetList,
      variables: {
        type: ASSET_TYPE.STOREFRONT_SKU,
        key: id,
      },
      fetchPolicy: 'no-cache',
    });
    return data.asRequestAssetsList.assetFiles;
  };

  handleFileUploadUrlRequest = async (request) => {
    const { filename, contentType } = request;
    const { id, client } = this.props;
    const { data } = await client.mutate({
      mutation: getUploadUrl,
      variables: {
        type: ASSET_TYPE.STOREFRONT_SKU,
        key: id,
        filename,
        contentType,
      },
      fetchPolicy: 'no-cache',
    });
    return data.asRequestAssetUploadUrl.uploadUrl.url;
  };

  render() {
    const { config, updateSKUMutation } = this.props;
    return (
      <Mutation mutation={updateSKUMutation}>
        {(updateSKU, { data, loading }) => (
          <ImageUpload
            {...this.props}
            loading={loading}
            onImageUpdate={this.handleImageUpdate(updateSKU)}
            onFileListRequest={this.handleFileListRequest}
            onFileUploadUrlRequest={this.handleFileUploadUrlRequest}
            uploadMode={config.assetUploadMode}
          />
        )}
      </Mutation>
    );
  }
}

export default compose(withApollo, withServerConfig())(SKUImageUpload);
